import { useBoolean } from "hooks";
import { useState } from "react";

export const useReturnModals = () => {
  const approveModal = useBoolean(false);

  const rejectModal = useBoolean(false);

  const [openedItemStatusesIndex, setOpenedItemStatusesIndex] = useState<
    number | null
  >(null);

  const [actionConfirmingIndex, setActionConfirmingIndex] = useState<
    number | null
  >(null);

  return {
    approveModal,
    rejectModal,
    openedItemStatusesIndex,
    setOpenedItemStatusesIndex,
    actionConfirmingIndex,
    setActionConfirmingIndex
  };
};
